document.addEventListener('DOMContentLoaded', function() {
    var id = '';
    if (document.getElementById('shopify-section-sections--24947008176499__section_qC4jQH')) {
        id = '#shopify-section-sections--24947008176499__section_qC4jQH';
    } 

    if(id) {
        const buttons = document.querySelectorAll(id + ' a.button-secondary');
        const images = document.querySelectorAll(id + ' .image-block');
    
        // Initialize first button and image as active
        buttons[0].classList.add('active');
        images[0].classList.add('active');
        
        buttons.forEach((button, index) => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                // Remove active classes from all buttons and images
                buttons.forEach(btn => btn.classList.remove('active'));
                images.forEach(img => img.classList.remove('active'));
                
                // Add active classes to clicked button and corresponding image
                this.classList.add('active');
                images[index].classList.add('active');
            });
        });
    }

    if(document.querySelector('.view-product-title a')) {
        var groupBlock = '#shopify-section-template--24947007750515__section_YNyTDU .group-block';
        switch (document.querySelector('.view-product-title a').textContent.trim()) {
            case 'Glucose Tablets - 50 Count Bottle':
            case 'Comprimés de glucose - Bouteille de 50 comprimés':
                document.querySelector(groupBlock + ':nth-child(1)').classList.add('active');
                break;
            case 'Glucose Tablets - 10 Count Tube':
            case 'Comprimés de glucose - Tube de 10 comprimés':
                document.querySelector(groupBlock + ':nth-child(2)').classList.add('active');
                break;
            case 'Glucose Gel Pouch':
            case 'Gel de glucose':
                document.querySelector(groupBlock + ':nth-child(3)').classList.add('active');
                break;
            case 'Liquiblast – Liquid Glucose':
            case 'Liquiblast – Glucose liquide':
                document.querySelector(groupBlock + ':nth-child(4)').classList.add('active');
                break;
            default:
                break;
        }
    }

    var isKlaviyoResponded = setInterval(() => {
        if(document.querySelectorAll('form.klaviyo-form > div > div').length > 1) {
            clearInterval(isKlaviyoResponded);

            document.querySelector('form.klaviyo-form > div').classList.add('responded');
        }
    }, 100);

    async function detectLocationByIP() {
        try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            
            //console.log('Country:', data.country_name);
            //console.log('Region:', data.region);
            //console.log('City:', data.city);

            const buttonsGroup = document.querySelectorAll('.buttons-group');
            if(buttonsGroup.length > 0) {
                buttonsGroup[0].style.display = 'flex';

                if(data.region == 'Quebec') {
                    buttonsGroup[1].style.display = 'flex';
                } else {
                    buttonsGroup[2].style.display = 'flex';
                }
            }
            
            return data;
        } catch (error) {
            console.error('Error getting IP location:', error);
        }
    }

    detectLocationByIP();
});